import React from 'react';
import Info from 'components/Tooltip/Info';
import Box from '@material-ui/core/Box';
import { TooltipProps } from '@material-ui/core/Tooltip';

interface HelpInputProps {
  tooltipContent?: React.ReactElement;
  tooltipProps?: TooltipProps;
  className?: string;
}

function withInfo<P extends object>(Component: React.ComponentType<P>) {
  return (props: P & HelpInputProps) => {
    const { tooltipContent, tooltipProps, className, ...componentProps } = props;
    const component = <Component {...(componentProps as P)} className={className} />;
    if (tooltipContent) {
      return (
        <Box position="relative">
          {component}
          <Info content={tooltipContent} tooltipProps={tooltipProps} help />
        </Box>
      );
    } else {
      return component;
    }
  };
}

export default withInfo;
